import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { IconButton, Grid, Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchComponent from './SearchComponent';
import Credits from '../Credits.js';
import ThirdColumn from './ThirdColumn';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppContext } from '../AppProvider';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import EditNoteIcon from '@mui/icons-material/EditNote';
import LoginModal from './loginModal.js';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Banner from './Banner/Banner.js';
import WordAddInBadge from '../writer/wordaddinbadge.js';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Home = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  
  const { isAuthenticated } = useAuth0();
  const { isSearchMoved, setIsSearchMoved, setCurrentConversation, setNewSearch, setErrorDisplay, setQueries, setIds, setIdHistory, userCredits, creditsLoading, totalUserCredits,
    dailyUserCredits, temporaryUserCreditsList, totalTemporaryUserCredits, lifetimeUserCredits, temporaryExpiries
   } = useAppContext();
  const { id } = useParams(); // Retrieve the ID from the URL
  const location = useLocation();
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const [isBannerVisible, setIsBannerVisible] = useState(true)
  const [initialUrlParam, setInitialUrlParam] = useState(null);
  const navigate = useNavigate()
  
  // Check if we're on the game path
  const isGamePath = location.pathname === '/game';
  
  useEffect(() => {
    // Handle URL parameter
    const queryParams = new URLSearchParams(location.search);
    const encodedUrl = queryParams.get('url');
    if (encodedUrl) {
      const decodedUrl = decodeURIComponent(encodedUrl);
      console.log('Encoded URL:', encodedUrl);
      console.log('Decoded URL:', decodedUrl);
      setInitialUrlParam(decodedUrl);
    }

    // console.log({ id });
    setCurrentConversation(id);
    setNewSearch(false);
    if (!id) {
      setNewSearch(true);
    }
  }, [id, location.search, setCurrentConversation, setNewSearch]);

  useEffect(() => {
    if (isSearchMoved) {
     setIsBannerVisible(false);
    }
  }, [isSearchMoved]);

  const createConversation = () => {
    setIsSearchMoved(false);
    setErrorDisplay("");
    setQueries([]);
    setIds([]);
    setCurrentConversation('');
    setIdHistory({});
    setNewSearch(true);
    window.history.replaceState(null, '', `/`);
    if (!isMdUp) {
      setSidebarOpen(false);
    }
  };

  // useEffect(() => {
  //   if (isMdUp) {
  //     setSidebarOpen(true);
  //   } else {
  //     setSidebarOpen(false);
  //   }
  // }, [isMdUp]);

  const toggleSidebar = () => {
    console.log('Toggling sidebar...', isSidebarOpen);

    setSidebarOpen(!isSidebarOpen);
  };

  const handleCloseSidebar = () => {
    console.log('Closing sidebar...');

    setSidebarOpen(false);
  };

  return (
    <Box
    sx={{
      overflow: 'hidden',
      width: '100%',
      //minHeight: '100vh', // Allow content to expand beyond viewport
      background: 'radial-gradient(circle at center, rgba(255, 255, 255, 1) 0%, #F1F3FE 60%, #F1F3FE 100%)',
      position: 'fixed'
    }}
  >
    <LoginModal />
    <Grid container sx={{ position: 'relative', minHeight: '100vh' }}>
      {/* Header Navbar */}
      <Grid
  container
  item
  xs={12}
  sx={{
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingY: { xs: 1, sm: 2 },
    paddingX: { xs: 1, sm: 2 },
    backgroundColor: 'transparent',
    position: 'sticky',
    top: 0,
    zIndex: 100000,
    borderBottom: isMdUp ? '2px solid #0066FF' : '1px solid #0066FF',
  }}
>
  {/* Sidebar Toggle (Left) */}
  {isAuthenticated && (
    <Box
      sx={{
        position: { xs: 'absolute', md: 'absolute' },
        left: { xs: 0, md: 15 },
        zIndex: 1300,
        display: 'flex',
        //alignItems: 'center',
      }}
    >
      <IconButton onClick={toggleSidebar}>
        <MenuIcon sx={{ color: '#0066FF' }} />
      </IconButton>
    </Box>
  )}

  {/* Centered Logo */}
  <Box
  sx={{
    position: { xs: 'absolute', md: 'absolute' },
    left: { xs: 60, md: '50%' }, // 16px = nice padding on mobile instead of 0
    transform: { xs: 'none', md: 'translateX(-50%)' },
    display: 'flex',
    alignItems: 'center',
  }}
>
  <a href="https://app.facticity.ai" style={{ textDecoration: 'none' }}>
    <img
      src="/facticityailogo-02.png"
      alt="Facticity.AI"
      style={{
        paddingTop: isMdUp ? '2px' : '3px',
        width: 'auto',
        height: isMdUp ? '32px' : '26px',
      }}
    />
  </a>
  </Box>

  {/* Credits (Right-Middle) */}
  {isAuthenticated && (
    <Box
      sx={{
        position: 'absolute',
        right: isMdUp ? 70 : 60,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <IconButton onClick={() => navigate('/rewards')} size="small" sx={{ ml: 1 }}>
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
      <Credits credits={userCredits} isLoading={creditsLoading} />
    </Box>
  )}

  {/* Right-most Element */}
  {(!isAuthenticated || isMdUp) ? (
    <Box sx={{ position: 'absolute', right: 15 }}>
      <ThirdColumn />
    </Box>
  ) : (
    <IconButton
      onClick={createConversation}
      sx={{
        position: 'absolute',
        right: 15,
        zIndex: 1000,
      }}
    >
      <AddBoxOutlinedIcon sx={{ color: '#0066FF' }} />
    </IconButton>
  )}

  {/* Sidebar Component */}
  {isAuthenticated && (
    <Sidebar
      isOpen={isSidebarOpen}
      handleCloseSidebar={handleCloseSidebar}
      toggleSidebar={toggleSidebar}
      sx={{ marginTop: '60px' }}
      setIsSearchMoved={setIsSearchMoved}
      createConversation={createConversation}
    />
  )}

  {/* Banner */}
  <Banner isVisible={isBannerVisible} setIsVisible={setIsBannerVisible} />
</Grid>


  
      {/* Main Content */}
      <Grid
        container
        item
        xs={12}
        sx={{
          flexGrow: 1,
          padding: { xs: 0.5, sm: 0.5 },
          position: 'relative',
        }}
      >   
        <Grid
          item
          xs={12}
          sx={{
            overflowY: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 60px)', // Ensures content isn't cut off
            position: 'relative',
          }}
        >
          <SearchComponent 
            isSearchMoved={isSearchMoved} 
            setIsSearchMoved={setIsSearchMoved} 
            isMdUp={isMdUp}
            initialUrlParam={initialUrlParam} 
          />
        </Grid>
      </Grid>
  
      {/* Optional: Additional Columns for Larger Screens */}
      {isMdUp && (
        <Grid item md={3} sx={{ display: { xs: 'none', md: 'block' } }}>
          {/* Your additional content for larger screens */}
        </Grid>
      )}
    </Grid>
  </Box>
  
  );
};

export default Home;